const mobileNav = document.querySelector('.nav__menu--mobile');
const navContainer = document.querySelector('section.nav');
const mobileHamburger = document.querySelector('.nav__menu--mobile .dropdown-toggle');

mobileHamburger.addEventListener('click', () => {
  mobileNav.classList.toggle('open-nav');
  navContainer.classList.toggle('open-nav');

  if (mobileNav.classList.contains('open-nav')) {
    document.querySelector('body').style.overflow = 'hidden';
  } else {
    document.querySelector('body').style.overflow = 'hidden visible';
  }
});


/* Language Switcher in Menus */
const switchers = document.querySelectorAll('.uni__menu--language');

switchers.forEach((switcher) => {
  const languageLink = switcher.querySelector('a.uni__language-switcher');

  languageLink.addEventListener('click', (e) => {
    e.preventDefault();

    switcher.classList.toggle('active-language');

  });
})
